import { Injectable } from '@angular/core';
import {ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Store} from "@ngrx/store";
import * as fromStore from "../../store";
import {first, switchMap} from "rxjs/operators";
import {CookieService} from "ngx-cookie";

@Injectable({
  providedIn: 'root'
})
export class RootGuard implements CanActivate {

  constructor(
    private readonly _router: Router,
    private readonly _route: ActivatedRoute,
    private readonly _store: Store<fromStore.DbStoreState>,
    private readonly _cookieService: CookieService,
  ) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.handleBoosterPlanRedirection();
    });
  }

  private handleBoosterPlanRedirection(): void {
    this._store.select(fromStore.getUserLoaded)
      .pipe(
        first(loaded => loaded),
        switchMap(() => this._store.select(fromStore.getUserSubscription)),
        first()
      )
      .subscribe(userSubscription => {
        const referralHashFromCookie = this._cookieService.get('dbReferralHash') || null;
        if (referralHashFromCookie) {
          localStorage.setItem('dbReferralHash', referralHashFromCookie);
        }
        let redirectTo = userSubscription && userSubscription.oneProductOrBundle ? '/download-plugins' : '/websites';

        this._router.navigate([redirectTo]);

      });
  }
}
